

















const loginType = localStorage.getItem('loginType')
import AccidentList from "@/components/AccidentList.vue";
import UserTree from "@/components/user-tree.vue";
import { api } from "@/plugins/api";
import { req } from "@/api/accident/list";
import router from "@/router";
import store from "@/store";
import { commonData, InsuranceData, hospitalData } from "@/views/dataStatistics.js";
import commonAccidentListCom from "../components/commonAccidentListCom.vue";
import carAccidentListCom from "../components/carAccidentListCom.vue";
import hospitalAccidentListCom from "../components/hospitalAccidentListCom.vue";
import mediatorAccidentListCom from "../components/mediatorAccidentListCom.vue";
import rescueCom from "../components/rescueCom.vue";

import { AccidentListBO } from "@/types/api-beans"; // 远程定责表头字典
import {
  computed,
  defineComponent,
  reactive,
  Ref,
  ref,
  getCurrentInstance,
  UnwrapRef,
} from "@vue/composition-api";
import StatisticsItem from "./statictics-item.vue";
import { getAccidentRoom, reEnterAccidentRoom, exitAccidentRoom } from "@/api";
import { getAccidentList, getHospitalList, getMediatorList } from '@/api/accident/list.js'
import { Mutations } from "@/store/mutations";
import asideCom from "@/views/components/asideCom/index.vue";
import { log } from "console";

export default defineComponent({
  name: "Index",
  components: {
    UserTree,
    StatisticsItem,
    AccidentList,
    commonAccidentListCom,
    carAccidentListCom,
    hospitalAccidentListCom,
    mediatorAccidentListCom,
    rescueCom,
    asideCom,
  },
  setup() {
    const statusMap = {
      0: "暂存",
      1: "处理中",
      2: "模拟中",
      3: "已归档",
      4: "注销",
    };
    const name: string = "上饶";
    const accidentList: Ref<Array<AccidentListBO>> = ref([]);
    const statisticsList: UnwrapRef<any[]> = reactive([]);
    const pagination = reactive({
      page: 1,
      size: 6,
      total: 0,
      type: 0
    });
    const currentRoomInfo: Ref<{ accidentId: string; phone: string }[]> = ref([]);
    // const params:Object | null = (getCurrentInstance() as any).proxy.$root.$route && (getCurrentInstance() as any).proxy.$root.$route.params;
    const exitId = sessionStorage.getItem("exitId");
    const userName: string = (store.state as any).user.username;
    // if (params && (params as any).exit && (params as any).id) {
    if (exitId) {
      exitRoom(exitId, userName);
    }
    let isRomeShow: boolean = true; // 控制接警房间的显示的标识
    let dataType: Ref<any[]> = ref([]); // 今天数据统计
    let listCom: string = "commonAccidentListCom"; //加载不同的列表
    getAccidentRoom().then(({ data = [] }) => {
      currentRoomInfo.value = data;
    });

    function formatPhone(phoneNumber: string) {
      return phoneNumber.replace(/(\d{3})(\d{4})(\d{4})/, "$1-$2-$3");
    }

    function backRoom(accidentId: string) {
      reEnterAccidentRoom(accidentId);
      store.commit(Mutations.CHANGE_LEAVE_STATE); // 修改离岗样式
      localStorage.setItem("isReady", "0");
      router.push({ name: "AccidentAdd", params: { id: accidentId } });
    }

    function exitRoom(accidentId: string, agentUserName: string) {
      exitAccidentRoom(accidentId, agentUserName)
        .then((res) => {
          currentRoomInfo.value.splice(
            currentRoomInfo.value.findIndex(
              ({ accidentId: findId }) => findId === accidentId
            ),
            1
          );
          api.video.trtc.ready.r().then((res: any) => {
            if (res.code === "200") {
              store.commit(Mutations.CHANGE_READY_STATE); // 修改就绪样式
              localStorage.setItem("isReady", "1");
            }
          }); // 就绪请求
          sessionStorage.setItem("exitId", "");
        })
        .catch((err) => {
          console.log("未退出通话：" + err);
        });
    }

    // 获取用户角色的信息,判断在首页需要加载的数据
    function getUserInfoToShow() {
      console.log(store.getters.searchCondition, 'store');
      let condition = store.getters.searchCondition.isSearch ? store.getters.searchCondition.searchQuery : { status: 3 }
      pagination.page = store.getters.searchCondition.isSearch ? store.getters.searchCondition.current : 1
      let roleString: string = "";
      const { total, ...params } = pagination;
      if (
        (store.state as any).user.roles.includes("TrafficPolice") ||
        (store.state as any).user.roles.includes("Agent") ||
        (store.state as any).user.roles.includes("admin")
      ) {
        if(loginType == '3185') {
          roleString = "Mediator";
        } else if(loginType == '3187'){
          roleString = "Rescue";
        } else {
          roleString = "Admin";
        }
      } else if ((store.state as any).user.roles.includes("Insurance")) {
        // 保险
        roleString = "Insurance";
      } else if ((store.state as any).user.roles.includes("Hospital")) {
        // 医院
        roleString = "Hospital";
        isRomeShow = false;
      }  else if ((store.state as any).user.roles.includes("Mediator")) {
        // 调解
        roleString = "Mediator";
        isRomeShow = false;
      }else if ((store.state as any).user.roles.includes("Trailer")) {
        // 拖车
        roleString = "Trailer";
        isRomeShow = false;
      } else if ((store.state as any).user.roles.includes("Repair")) {
        // 修车
        roleString = "Repair";
        isRomeShow = false;
      } else if ((store.state as any).user.roles.includes("Rescue")) {
        // 救援
        roleString = "Rescue";
        isRomeShow = false;
      } else {
        roleString = "Other";
      }
      if (localStorage.getItem('loginType')==='3187') {
        params.type = 1;
      }
      switch (roleString) {
        case "Admin":
          if (localStorage.getItem('loginType')==='3191') {
            dataType = hospitalData;
          }else {
            dataType = commonData;
          }
          listCom = "commonAccidentListCom";
          //@ts-ignore
          // params.status = 3
          getAccidentList(condition, params)
              .then((res: any) => {
                console.log(res, "com");
                pagination.total = res.data.total as number;
                accidentList.value = res.data.list!;
                listLoading.value = false;
              })
              .catch((err: any) => {
                console.log(err);
                listLoading.value = false;
              });
            console.log("Admin", isRomeShow);
          break;
        case "Insurance":
          dataType = InsuranceData;
          listCom = "commonAccidentListCom";
          // @ts-ignore
          // params.status = 3
          getAccidentList(condition, params)
            .then((res: any) => {
              console.log(res, "com");
              pagination.total = res.data.total as number;
              accidentList.value = res.data.list!;
              listLoading.value = false;
            })
            .catch((err: any) => {
              console.log(err);
              listLoading.value = false;
            });
          console.log("Insurance", isRomeShow);
          break;
        case "Hospital":
          dataType = hospitalData;
          listCom = "hospitalAccidentListCom";
          if(!store.getters.searchCondition.isSearch){
            req("/accident/getHospitalList/today", "get", params)
            .then((res: any) => {
              console.log(res, "hos");
              pagination.total = res.data.total as number;
              accidentList.value = res.data.list!;
              listLoading.value = false;
            })
            .catch((err: any) => {
              console.log(err);
              listLoading.value = false;
            });
          }else{
            getHospitalList(condition, params)
            .then((res: any) => {
              console.log(res.data.list, 'hospital');
              pagination.total = res.data.total as number
              accidentList.value = res.data.list!
              listLoading.value = false
            })
            .catch((err: any) => {
              console.log(err);
              listLoading.value = false
            })
          }

          console.log("Hospital", isRomeShow);
          break;
        case "Mediator":
          dataType = hospitalData;
          listCom = "mediatorAccidentListCom";
          if(!store.getters.searchCondition.isSearch){
            req("/mediator/today", "get", params)
              .then((res: any) => {
                console.log(res, "hos");
                pagination.total = res.data.total as number;
                accidentList.value = res.data.list!;
                listLoading.value = false;
              })
              .catch((err: any) => {
                console.log(err);
                listLoading.value = false;
              });
          }else{
            getMediatorList(condition, params)
              .then((res: any) => {
                console.log(res.data.list, 'hospital');
                pagination.total = res.data.total as number
                accidentList.value = res.data.list!
                listLoading.value = false
              })
              .catch((err: any) => {
                console.log(err);
                listLoading.value = false
              })
          }
          console.log("Hospital", isRomeShow);
          break;
        case "Rescue":
          listCom = "rescueCom";
          break;
        case "Trailer":
          dataType = hospitalData;
          listCom = "carAccidentListCom";
          req("/accident/getCarRescueList/today", "get", params)
            .then((res: any) => {
              console.log(res, "car");
              pagination.total = res.data.total as number;
              accidentList.value = res.data.list!;
              listLoading.value = false;
            })
            .catch((err: any) => {
              console.log(err);
              listLoading.value = false;
            });
          console.log("Trailer", isRomeShow);
          break;
        case "Repair":
          dataType = hospitalData;
          listCom = "carAccidentListCom";
          req("/accident/getCarRescueList/today", "get", params)
            .then((res: any) => {
              console.log(res, "car");
              pagination.total = res.data.total as number;
              accidentList.value = res.data.list!;
              listLoading.value = false;
            })
            .catch((err: any) => {
              console.log(err);
              listLoading.value = false;
            });
          console.log("Repair", isRomeShow);
          break;
        default:
          dataType = commonData;
          listCom = "commonAccidentListCom";
          req("/accident/list/today", "get", params)
            .then((res: any) => {
              console.log(res);
              pagination.total = res.data.total as number;
              accidentList.value = res.data.list!;
              listLoading.value = false;
            })
            .catch((err: any) => {
              console.log(err);
              listLoading.value = false;
            });
          console.log("角色判断出错,检查一下!");
          break;
      }
    }

    getUserInfoToShow();

    const colors = ["rgb(67 145 254)", "rgb(17 139 254)", "rgb(58 186 210)"];

    const addStatisticsItem = (item) => {
      item.color = colors[statisticsList.length % 3];
      statisticsList.push(item);
    };

    // 请求今日数据统计的数据
    // api.workstation.data.getData
    //   .r({ loginType: localStorage.getItem("loginType") })
    //   .then((data) => {
    //     dataType.map((item) => {
    //       if (data[item.split(":")[0]]) {
    //         addStatisticsItem({
    //           title: item.split(":")[1].trim(),
    //           value: data[item.split(":")[0]],
    //           icon: "/images/home/" + item.split(":")[1].trim() + ".png",
    //           color: statisticsList.length % 3,
    //         });
    //       }
    //     });
    //   });

    // 获取列表
    const listLoading = ref(true);
    const getStatusName = (code) => {
      return statusMap[code] ?? "-";
    };

    const showDetail = (id: string) => {
      router.push("/accIdent/edit/" + id);
    };

    const hasRole = (role: string) => {
      return (store.state as any).user.roles.includes(role);
    };

    return {
      showDetail,
      currentRoomInfo,
      name,
      accidentList,
      pagination,
      formatPhone,
      statisticsList,
      getStatusName,
      hasRole,
      listLoading,
      getUserInfoToShow,
      backRoom,
      exitRoom,
      isRomeShow,
      listCom,
      dataType,
    };
  },
});
